import { createApiClient } from "./client";
import { listInstitutions } from "./endpoints";
import type { InstitutionDto } from "./dtos";

const api = createApiClient();

let cache: InstitutionDto[] | null = null;
let inflight: Promise<InstitutionDto[]> | null = null;

/**
 * Fetch once and cache. Propagates network/HTTP errors to caller.
 * Returns [] only when server responded 200 with an empty array.
 */
export async function fetchInstitutionsOnce(): Promise<InstitutionDto[]> {
    if (cache) return cache;
    if (inflight) return inflight;

    inflight = listInstitutions(api)
        .then((items) => {
            cache = Array.isArray(items) ? items : [];
            inflight = null;
            return cache;
        })
        .catch((err) => {
            inflight = null;
            // Let the caller (UI) decide how to render the error.
            throw err;
        });

    return inflight;
}

export function getCachedInstitutions(): InstitutionDto[] | null {
    return cache;
}

/** Clear cache so the UI can retry a fresh request. */
export function resetInstitutionsCache(): void {
    cache = null;
    inflight = null;
}
